import { useMemo } from 'react';

import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useTranslationsContext } from '~/contexts/TranslationsContext/TranslationsContext';
import { buildTranslate } from '~/utils/translations/buildTranslate';

export function useTranslation() {
  const { businessUnit } = useBusinessUnitContext();
  const { translations } = useTranslationsContext();

  return useMemo(() => buildTranslate(translations, businessUnit), [businessUnit, translations]);
}
